<header class="analytehealth-header" [class.nav-active]="mobileMenuActive">
  <div class="header-container">
    <div class="header-inner">
      <a class="logo" href="{{ siteUrl }}/" data-qa-id="clickable-logo">
        <img ngSrc="assets/img/analytehealth-logo.svg" alt="Analyte Health Logo" width="270" height="24" priority />
      </a>
      <div class="menu-drop" id="main-nav" (click)="closeMenu()">
        <nav class="menu-drop-wrap" aria-label="Main navigation">
          <ul class="menu">
            <li><a href="{{ siteUrl }}/our-solution/" data-qa-id="analytehealth-nav-our-solution">Our Solution</a></li>
            <li><a href="{{ siteUrl }}/partnership/" data-qa-id="analytehealth-nav-partnership">Partnership</a></li>
            <li><a href="{{ siteUrl }}/careers/" data-qa-id="analytehealth-nav-careers">Careers</a></li>
            <li><a href="{{ siteUrl }}/about/" data-qa-id="analytehealth-nav-about">About</a></li>
          </ul>
        </nav>
      </div>
      <button
        class="menu-opener"
        type="button"
        data-qa-id="analytehealth-menu-opener"
        [attr.aria-expanded]="mobileMenuActive"
        aria-controls="main-nav"
        [attr.aria-label]="mobileMenuActive ? 'Close navigation menu' : 'Open navigation menu'"
        (click)="toggleMenu()"
      >
        <span aria-hidden="true"></span>
      </button>
    </div>
  </div>
</header>
<div class="main-content">
  <ng-content></ng-content>
</div>
<footer class="analytehealth-footer">
  <div class="footer-container">
    <div class="footer-inner">
      <div class="footer-brand">
        <img
          class="footer-logo"
          ngSrc="assets/img/analytehealth-logo-white.svg"
          alt="Analyte Health Logo"
          data-qa-id="analytehealth-footer-logo"
          width="344"
          height="31"
          priority
        />
        <a class="footer-phone" href="tel:{{ phoneNumberDigits }}" data-qa-id="analytehealth-phone-number">
          {{ phoneNumber }}
        </a>
      </div>
      <nav class="footer-nav">
        <a href="{{ siteUrl }}/partnership/" data-qa-id="analytehealth-footer-partnership">Partner with Us</a>
        <a href="{{ siteUrl }}/terms-of-service/" data-qa-id="analytehealth-footer-terms-of-service"
          >Terms of Service</a
        >
      </nav>
    </div>
    <div class="footer-bottom">
      <p>Copyright &copy; {{ today | date: 'y' }} Analyte Health, All rights reserved.</p>
    </div>
  </div>
</footer>
